/** A reference image attached to the home-page prompt.
 *
 *  `file` is set for an upload (saved or not) and is what generation sends.
 *  `assetId` is set when the image is a library asset and there is no file to
 *  send — the server resolves those bytes. `assetName` is set only when the
 *  image is that asset, and is what the pill shows instead of "Reference Image N".
 */
export interface ReferenceAttachment {
  previewUrl: string;
  file: File | null;
  assetId: string | null;
  assetName: string | null;
}

export function referenceImageLabel(
  index: number,
  assetName: string | null | undefined,
): string {
  const name = assetName?.trim();
  if (name) return name;
  return `Reference Image ${index + 1}`;
}

/** Router state for a generation that may mix uploads and saved assets.
 *  The three arrays stay index-aligned; an empty list omits them. */
export function generationReferenceState(references: ReferenceAttachment[]): {
  uploadedFiles?: (File | null)[];
  referenceImagePreviews?: string[];
  referenceAssetIds?: (string | null)[];
} {
  if (references.length === 0) return {};
  return {
    uploadedFiles: references.map((reference) => reference.file),
    referenceImagePreviews: references.map((reference) => reference.previewUrl),
    referenceAssetIds: references.map((reference) => reference.assetId),
  };
}
